import React, { useEffect, useState } from 'react';

import SweetAlert from 'react-bootstrap-sweetalert';
import styles from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js';
import { makeStyles } from '@material-ui/core/styles';

import { wsPost } from 'services/WService';

const useStyles = makeStyles(styles);

export default function AlertConfirm({
  show, // mostrar alerta
  idOrder, // id de la orden
  message, // mostrar el mensaje "Aprobar " || "Anular"
  messageMessage = undefined, // Reemplaza a esta acción tiene consecuencias
  action, // evento de aprobar o anular
  showNotify, // mostrar mensaje del response
  reload = undefined, // opcion para recargar los datos
  close, // cerrar ventana de confirmacion
  ObjType = '13',
}) {
  const classes = useStyles();

  const [alert, setAlert] = useState(null);

  function confirm(orderId, text, status) {
    if (!orderId) return;
    let isApprove = status === 'Y' ? true : false;

    const hideAlert = () => {
      setAlert(null);
      close();
    };

    setAlert(
      <SweetAlert
        warning={isApprove}
        input={!isApprove}
        inputType={isApprove ? 'number' : 'text'}
        defaultValue=""
        style={{ display: 'block', marginTop: '-100px' }}
        title={'¿Esta seguro de ' + text + ' ?'}
        isDisabled={true}
        onConfirm={(e) => {
          if (isApprove) {
            approveOrCancel(orderId, true);
          } else {
            approveOrCancel(orderId, false, { ObservacionError: e });
          }
          hideAlert();
        }}
        onCancel={hideAlert}
        confirmBtnCssClass={classes.button + ' ' + classes.success}
        cancelBtnCssClass={classes.button + ' ' + classes.danger}
        confirmBtnText="Aceptar"
        cancelBtnText="Cancelar"
        showCancel
      >
        {isApprove
          ? messageMessage ?? '¡Esta acción tiene consecuencias!' : 'Ingrese el motivo por favor :)'}
      </SweetAlert>,
    );
  }

  async function approveOrCancel(orderId, status, data = undefined) {
    let annularUrl = `ordm/order/${orderId}/${status ? 'approve-commited' : 'annular-commited'}`;
    if(ObjType === '14'){
      annularUrl = `sale/credit-note/${orderId}/annular`;
    }
    let response = await wsPost(
      annularUrl,
      data === undefined ? '' : data
    );
    if (response.success) {
      showNotify(response.message);
      if (reload) reload();
    } else {
      showNotify(response.message, 'error');
    }
  }

  useEffect(() => {
    if (show) confirm(idOrder, message, action);
  }, [show]);

  return alert;
}
